<template>
    <v-toolbar
        v-if="displayToolbar"
        id="tickets-mobile-data-toolbar"
        flat
        class="px-3"
    >
        <div class="checkbox-container">
            <slot name="selectCheckbox" />
            <slot name="clipboardCheckbox" />
        </div>
        <v-spacer />
        <DownloadDialog
            :selected-tickets="selectedTickets"
        />
        <SendTicketDialog
            :selected-tickets="selectedTickets"
        />
        <PrintTicketsDialog
            :selected-tickets="selectedTickets"
        />
        <!-- CWTM-636 feature hidden
        <v-icon
            class="mr-7"
            :disabled="differencesDisabled"
            @click="emitCompare"
        >
            mdi-compare
        </v-icon> -->
        <v-btn 
            v-if="showCog"
            icon
            @click="emitTicketConfig"
        >
            <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
    </v-toolbar>
</template>
<script>
import DownloadDialog from './TicketsDownload.vue';
import SendTicketDialog from './TicketsSend.vue';
import PrintTicketsDialog from './PrintTickets';

export default {
    components: {
        DownloadDialog,
        SendTicketDialog,
        PrintTicketsDialog,
    },
    props: {
        displayToolbar: {
            type: Boolean,
        },
        selectedTickets: {
            type: Array,
            default: () => [],
        },
        differencesDisabled: {
            type: Boolean,
        },
        reopenDisabled: {
            type: Boolean
        },
        respondDisabled: {
            type: Boolean
        },
        assignDisabled: {
            type: Boolean
        },    
    },
    data: () => ({
        tableMapToggle: 'table',
    }),
    methods: {
        emitCompare() {
            this.$emit('open-compare-dialog');
        },
        emitRespond() {
            this.$emit('open-respond-dialog');
        },
        emitAssign() {
            this.$emit('open-assign-dialog');
        },
        emitTicketConfig() {
            this.$emit('open-ticket-table-config');
        },
        showCog() {
            return this.activeTab.tabId !== 'tickets-clipboard';
        },        
    }
};
</script>
<style>
#ticket-cards .checkbox-container {
    display: flex;
    padding-top:16px;
}
</style>